const removeWaterMark = {
  ExportVideoWithoutWaterMark: "Exportar vídeo sem marca d'água'",
  ExportWithoutLimits: 'Exportar vídeo sem limites',
  MaximumUpload500MB: 'Tamaño Máximo del Archivo Cargado: 500 MB',
  watermarkRemoveTitle: 'HitPaw Online Video Watermark Remover',
  DiscountPrice: 'R$4.99',
  WeekTotalPrice: 'R$21,99',

  MonthWeekPrice: 'R$8,99',
  MonthTotalPrice: 'R$81,99',

  YearWeekPrice: 'R$4,39',
  YearTotalPrice: 'R$219,99',
  Day: 'Dia',
  Monthly: 'Mensalmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
  week: 'Semana',
};

export default removeWaterMark;
